import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";
export function signTimeSheetReducer() {
    return combineReducers({
        TabelDetail_TabelChiefPO_View: createItemReducer("SignTimeSheet", "TabelDetail.TabelChiefPO_View", false),
        TabelDetail_TabelChiefPO_ViewParams: createItemReducerParams("SignTimeSheet", "TabelDetail.TabelChiefPO_View"),
        TabelDetail_TabelChiefPO_Do_SetMySign: createItemReducer("SignTimeSheet", "TabelDetail.TabelChiefPO_Do_SetMySign", false),
        TabelDetail_TabelChiefPO_CtrlParams : createItemReducer("SignTimeSheet", "TabelDetail.TabelChiefPO_CtrlParams", false),
        TabelDetail_TabelHistPO_View: createItemReducer("SignTimeSheet", "TabelDetail.TabelHistPO_View", false),
    });
}